(() => {
  const header = document.querySelector("[data-ao-header]");
  const drawer = document.querySelector("[data-ao-drawer]");
  const menuToggle = document.querySelector("[data-ao-menu-toggle]");
  const closeButtons = document.querySelectorAll("[data-ao-menu-close]");
  const navDetails = document.querySelectorAll("[data-ao-nav-details]");

  const setScrolledState = () => {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 12);
  };

  const openDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.hidden = false;
    document.body.classList.add("ao-no-scroll");
    menuToggle.setAttribute("aria-expanded", "true");
  };

  const closeDrawer = () => {
    if (!drawer || !menuToggle) return;
    drawer.hidden = true;
    document.body.classList.remove("ao-no-scroll");
    menuToggle.setAttribute("aria-expanded", "false");
  };

  window.addEventListener("scroll", setScrolledState, { passive: true });
  window.addEventListener("load", setScrolledState);
  setScrolledState();

  if (menuToggle) {
    menuToggle.addEventListener("click", openDrawer);
  }

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
      navDetails.forEach((detail) => detail.removeAttribute("open"));
    }
  });

  document.addEventListener("click", (event) => {
    navDetails.forEach((detail) => {
      if (!detail.contains(event.target)) {
        detail.removeAttribute("open");
      }
    });
  });
})();